import { FunctionComponent } from 'react';
import { PageContentContainer } from '../../app-kit/components/PageContentContainer/PageContentContainer';
import { SchoolPageTabContentContainer } from '../containers/SchoolPageTabContentContainer/SchoolPageTabContentContainer';
import { SchoolContentHeader } from '../components/SchoolContentHeader/SchoolContentHeader';

interface SchoolPageScreenProps {
  childPath?: string;
}

export const SchoolPageScreen: FunctionComponent<SchoolPageScreenProps> = ({ childPath }) => {
  return (
    <PageContentContainer>
      <SchoolContentHeader />
      <SchoolPageTabContentContainer childPath={childPath} />
    </PageContentContainer>
  );
};
